import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export default function Map({ cue }) {
	const settings = useSelector((state) => state.main?.settings);

	if (!settings.google_maps_api_key) return ["Google Maps API key missing"];

	return <MapInternals cue={cue} />;
}

let markers = []

const GoogleMapsScript = ({ cue, googleMapsApiKey = "" }) => {
	const [map, setMap] = useState(null);
	const [previousString, setPreviousString] = useState("");
	const { projectId } = useParams();
	const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);

	let url = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${googleMapsApiKey}`;


	const handleAddPlace = (sentence = "") => {
		if (!map) return null;

		const regex = /.*? from (.*) (.*)|.*? in (.*) (.*)/;
		const replaced = sentence.replace(regex, "$1 $2");

		const request = {
			query: replaced,
			fields: ["name", "geometry"],
		};

		let service = new window.google.maps.places.PlacesService(map);

		service.findPlaceFromQuery(request, function (results, status) {
			if (status === window.google?.maps?.places?.PlacesServiceStatus.OK) {
				const marker = new window.google.maps.Marker({
					position: results[0].geometry.location,
					map: map,
				});
				// showChatMessage(chat);
				markers.push(marker);
			} else {
				return null;
			}
		});
	};

	const clearMapPins = () => {
		markers.forEach((marker) => marker.setMap(null))
	}
	useEffect(()=>{clearMapPins()}, [cue.removePinCount])

	useEffect(() => {
		// Check if the script is already present
		const script = document.createElement("script");
		if (!document.querySelector(`[src="${url}"]`)) {
			script.src = url;
			script.async = true;
			document.body.appendChild(script);

			script.onload = () => {
				let map = new window.google.maps.Map(document.getElementById("map"), {
					center: {
						lat: parseFloat(cue?.lat) || 51.5,
						lng: parseFloat(cue?.long) || 0,
					}, // { lat: +/-85(31 mid), lng: 16 }
					zoom: parseInt(cue?.zoomLevel) || 4,
					disableDefaultUI: true,
					mapTypeId: cue?.mapType || "terrain", // satellite, terrain, hybrid
				});
				setMap(map);
			};
		}
		return () => {
			document.body.removeChild(script);
		};
	}, [cue.mapType, cue.lat, cue.long, cue.zoomLevel]);

	useEffect(() => {
		const cues = selectedProject.cues;
		const filtered = cues.filter((c) => c.type === "social")[0];

		if (filtered) {
			let string = filtered?.chat?.snippet?.displayMessage;
			if (string !== previousString) {
				setPreviousString(string);
				handleAddPlace(string);
			} else {
				return null;
			}
		}
	}, [selectedProject.cues]);

	return <div id="map" className="w-screen h-screen"></div>;
};

const MapInternals = ({ cue }) => {
	const settings = useSelector((state) => state.main?.settings);

	if (settings.google_maps_api_key)
		return (
			<GoogleMapsScript
				cue={cue}
				googleMapsApiKey={settings.google_maps_api_key}
			/>
		);
};
